import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5668e047"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "Ttns" }
const _hoisted_2 = { class: "mt-4 bg-white rounded" }
const _hoisted_3 = { class: "flex items-center justify-end py-3" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-download" }, null, -1))
const _hoisted_5 = { class: "TtnsTable" }
const _hoisted_6 = {
  key: 0,
  class: "flex flex-col items-center justify-center text-sm text-gray-400 select-none"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mt-1" }, "Загрузка списка рейсов...", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-red-500" }, "При получении списка рейсов произошла ошибка", -1))
const _hoisted_9 = { key: 2 }
const _hoisted_10 = {
  key: 1,
  class: "TtnsTable"
}
const _hoisted_11 = { class: "flex items-center justify-end pb-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_tabs = _resolveComponent("tabs")!
  const _component_new_select = _resolveComponent("new-select")!
  const _component_new_modal = _resolveComponent("new-modal")!
  const _component_ttn_edit_modal = _resolveComponent("ttn-edit-modal")!
  const _component_TtnTMSFilters = _resolveComponent("TtnTMSFilters")!
  const _component_new_button = _resolveComponent("new-button")!
  const _component_new_limit = _resolveComponent("new-limit")!
  const _component_new_pagination = _resolveComponent("new-pagination")!
  const _component_loader = _resolveComponent("loader")!
  const _component_ttns_tms_row = _resolveComponent("ttns-tms-row")!
  const _component_button_dropdown = _resolveComponent("button-dropdown")!
  const _component_new_table = _resolveComponent("new-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_tabs, {
      tabs: _ctx.tabs,
      "is-new": ""
    }, null, 8, ["tabs"]),
    (_ctx.cancel_state.is_open)
      ? (_openBlock(), _createBlock(_component_new_modal, {
          key: 0,
          title: "Добавить комментарий",
          loading: _ctx.cancel_state.is_loading,
          onSubmit: _ctx.setComment,
          onCancel: _ctx.toggleCancel
        }, {
          default: _withCtx(() => [
            _createVNode(_component_new_select, {
              value: _ctx.cancel_state.commentId,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.cancel_state.commentId) = $event)),
              placeholder: "Выберите комментарий",
              options: _ctx.comments_state.list,
              loading: _ctx.comments_state.is_loading,
              failed: _ctx.comments_state.is_failed,
              disabled: _ctx.comments_state.is_loading,
              "is-invalid": _ctx.state_form$.commentId.$error,
              "validation-errors": _ctx.state_form$.commentId.$errors,
              "error-text": "При получении списка комментариев произошла ошибка",
              "search-without-refresh": ""
            }, null, 8, ["value", "options", "loading", "failed", "disabled", "is-invalid", "validation-errors"])
          ]),
          _: 1
        }, 8, ["loading", "onSubmit", "onCancel"]))
      : _createCommentVNode("", true),
    (_ctx.edit_state.is_open)
      ? (_openBlock(), _createBlock(_component_ttn_edit_modal, {
          key: 1,
          item: _ctx.edit_state.item,
          onClose: _ctx.closeEdit
        }, null, 8, ["item", "onClose"]))
      : _createCommentVNode("", true),
    _createVNode(_component_TtnTMSFilters, {
      class: "mt-5",
      loading: _ctx.state.is_loading,
      disabled: _ctx.state.is_loading,
      onSubmit: _ctx.onFiltersChanged,
      onReset: _ctx.onFiltersReset
    }, null, 8, ["loading", "disabled", "onSubmit", "onReset"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.havePermissions(['tms.ttn-index']))
          ? (_openBlock(), _createBlock(_component_new_button, {
              key: 0,
              loading: _ctx.state.is_excel_loading,
              disabled: _ctx.state.is_excel_loading,
              class: "NewButton--medium NewButton--square mr-3",
              onClick: _ctx.downloadReportTtns
            }, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            }, 8, ["loading", "disabled", "onClick"]))
          : _createCommentVNode("", true),
        _createVNode(_component_new_limit, {
          disabled: _ctx.state.is_loading,
          value: _ctx.state.pagination.limit,
          "total-items": _ctx.state.pagination.total_items,
          onChange: _ctx.onLimitChange
        }, null, 8, ["disabled", "value", "total-items", "onChange"]),
        _createVNode(_component_new_pagination, {
          class: "ml-6",
          disabled: _ctx.state.is_loading,
          "current-page": _ctx.state.pagination.page,
          "total-pages": _ctx.state.pagination.total_pages,
          onChangePage: _ctx.onChangePage
        }, null, 8, ["disabled", "current-page", "total-pages", "onChangePage"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        (_ctx.state.is_loading || _ctx.state.is_failed || _ctx.state.list.length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              (_ctx.state.is_loading)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createVNode(_component_loader, { class: "primary" }),
                    _hoisted_7
                  ], 64))
                : (_ctx.state.is_failed)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _hoisted_8,
                      _createVNode(_component_new_button, {
                        class: "mt-1",
                        onClick: _ctx.loadTtns
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Перезагрузить ")
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ], 64))
                  : (_ctx.state.list.length === 0)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_9, "Список рейсов пуст"))
                    : _createCommentVNode("", true)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createVNode(_component_new_table, {
                columns: _ctx.TABLE_COLUMNS,
                rows: _ctx.state.list
              }, {
                td: _withCtx(({ column, row }) => [
                  _createVNode(_component_ttns_tms_row, {
                    column: column,
                    row: row,
                    index: _ctx.state.list.indexOf(row)
                  }, null, 8, ["column", "row", "index"])
                ]),
                actions: _withCtx(({ row }) => [
                  _createVNode(_component_button_dropdown, { icon: "fas fa-ellipsis-h" }, {
                    default: _withCtx(() => [
                      (_ctx.havePermissions(['tms.ttn-set-comment']))
                        ? (_openBlock(), _createBlock(_component_new_button, {
                            key: 0,
                            class: "NewButton--transparent TripsTable__btn",
                            onClick: ($event: any) => (_ctx.toggleCancel(row.id))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Добавить комментарий ")
                            ]),
                            _: 2
                          }, 1032, ["onClick"]))
                        : _createCommentVNode("", true),
                      _createVNode(_component_new_button, {
                        class: "NewButton--transparent TripsTable__btn",
                        onClick: ($event: any) => (_ctx.openEdit(row))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Редактировать ")
                        ]),
                        _: 2
                      }, 1032, ["onClick"])
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 1
              }, 8, ["columns", "rows"])
            ]))
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_new_limit, {
          disabled: _ctx.state.is_loading,
          value: _ctx.state.pagination.limit,
          "total-items": _ctx.state.pagination.total_items,
          onChange: _ctx.onLimitChange
        }, null, 8, ["disabled", "value", "total-items", "onChange"]),
        _createVNode(_component_new_pagination, {
          class: "ml-6",
          disabled: _ctx.state.is_loading,
          "current-page": _ctx.state.pagination.page,
          "total-pages": _ctx.state.pagination.total_pages,
          onChangePage: _ctx.onChangePage
        }, null, 8, ["disabled", "current-page", "total-pages", "onChangePage"])
      ])
    ])
  ]))
}